import React from 'react';
import { Button, Icon, Typography } from '@saviynt/design-system';
import { useHistory } from 'react-router-dom';

import useGetDashboardDetails from '../../../hooks/use-getdashboarddetails';
import { useInvertedLocalize } from '../../../utils';
import JOB_STATUS, { TAB_VALUES } from '../constants';

import invertedMessages from './messages';

import './Header.css';

interface HeaderProps {
  activeTab: string;
}

export default function Header({ activeTab }: HeaderProps) {
  const history = useHistory();
  const l = useInvertedLocalize(invertedMessages);

  const { data, isLoading } = useGetDashboardDetails();

  const isJobNotStarted = data?.jobStatus.status === JOB_STATUS.NOT_STARTED;

  const handleManageClassification = () => {
    history.push({ pathname: '/manageClassification' });
  };

  return (
    <header className='Ext-Header' data-testid='ext-dashboard-header'>
      <div className='Ext-Header-title'>
        <Typography kind='display'>Identities</Typography>
      </div>
      {!isLoading && !isJobNotStarted && activeTab === TAB_VALUES.EXTERNAL && (
        <div className='Ext-Header-buttonContainer'>
          <Button
            className='manage-button'
            type='button'
            kind='subtle'
            onClick={handleManageClassification}
            leftIcon={<Icon kind='Configure' />}>
            {l('Manage Classification Rules')}
          </Button>
        </div>
      )}
    </header>
  );
}
